export const miraFeatureModules = [
    feature('startup', ['startup']),
    feature('auth', ['login', 'register']),
    feature('onboarding', ['onboarding-profile', 'onboarding-birth', 'onboarding-relationship']),
    feature('today', ['today']),
    feature('chat', ['chat']),
    feature('topics', ['topics', 'topic-detail']),
    feature('relationships', ['relationships', 'relationship-new', 'relationship-detail']),
    feature('memory', ['memory']),
    feature('settings', ['settings', 'settings-profile', 'settings-birth', 'settings-password', 'settings-privacy']),
    feature('legal', ['privacy', 'terms']),
];
export function featureForRoute(routeId) {
    const owner = miraFeatureModules.find((item) => item.routeIds.includes(routeId));
    if (!owner)
        throw new Error(`No feature owner for Mira route: ${routeId}`);
    return owner;
}
function feature(id, routeIds) {
    return { id, routeIds };
}
